export const goBack = () => {
  // TODO: make sure we can go back without leaving Inventora
  window.history.back()
}
